<template>
  <Dialog
    :visible.sync="dialogVisible"
    :style="{ width: '500px' }"
    :header=clientName
    @show="checkNepaliDateOrEnglishNext"
  >
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks">Remarks <span style="color:red">*</span></label>
        <Textarea
          id="remarks"
          v-model="remarksData.remarks"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks1">Remarks 1</label>
        <Textarea
          id="remarks1"
          v-model="remarksData.remarks1"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks2">Remarks 2</label>
        <Textarea
          id="remarks2"
          v-model="remarksData.remarks2"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-lg-6 p-xl-2">
        <label>Next Follow-up Date</label>
        <date-picker
          ref="nxt"
          v-model="nextFollowUpDate"
          valueType="format"
          v-if="!englishDateEnabled"
        />
        <input-mask
          mask="9999-99-99"
          ref="nxt"
          v-else
          class="nepali-calendar"
          id="nextFollowUpDate"
          :append-to-body="true"
          v-model="nextFollowUpDate"
        />
      </div>
      <div class="p-field p-col-12 p-lg-6 p-xl-2">
      <label>Follow-up Time</label>
      <Calendar 
        id="followUpTime" 
        v-model="remarksData.followUpTime" 
        :timeOnly="true" 
        :showSeconds="false"
        :hourFormat="'24'"
        :showIcon="true"
        :stepMinute="5"
        placeholder="Select Time"
      />
    </div>
      
      <!-- <div class="p-field p-col-12 p-md-6">
        <label for="nextFollowUpDate">Next Follow-up Date</label>
        <DatePicker
          ref="tran"
          v-model="nextFollowUpDate"
          valueType="format"
          format="yyyy-MM-dd"
          @change="updateNextFollowUpDate"
        />
        <InputMask
          mask="9999-99-99"
          ref="tran"
          class="nepali-calendar"
          id="nextFollowUpDate"
          v-model="nextFollowUpDate"
        />
      </div> -->
    </div>
    <template #footer>
      <Button
        label="Save"
        icon="pi pi-check"
        class="p-button p-button-raised p-button-primary"
        @click="saveRemarks"
      />
      <Button
        label="Cancel"
        icon="pi pi-times"
        class="p-button p-button-raised p-button-danger"
        @click="closeDialog"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import DatePicker from 'vue2-datepicker'
import InputMask from 'primevue/inputmask'
import Calendar from 'primevue/calendar'
import $ from 'jquery'
export default {
  name: 'RemarksDialog',
  components: {
    Dialog,
    Calendar,
    Button,
    DatePicker,
    InputMask,
    Textarea
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialRemarks: {
      type: Object,
      default: () => ({
        remarks: '',
        remarks1: '',
        remarks2: '',
        clientName: '',
        followUpTime: null,
        nextFollowUpDate: null
      })
    }
  },
  data() {
    return {
      dialogVisible: false,
      englishDateEnabled: true,
      nextFollowUpDate: null,
      followUpTime: null,
      remarksData: {
        remarks: '',
        remarks1: '',
        remarks2: '',
        clientName: '',
        nextFollowUpDate: null,
        followUpTime: null
      }
    }
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue
      if (newValue) {
        this.remarksData = { ...this.initialRemarks }
        if (this.remarksData.followUpTime) {
          this.remarksData.followUpTime = this.cleanTimeFormat(this.remarksData.followUpTime)
        }
        this.nextFollowUpDate = this.remarksData.nextFollowUpDate
      }
    },
    nextFollowUpDate(newValue) {
      this.remarksData.nextFollowUpDate = newValue
    }
  },
  methods: {
    saveRemarks() {
      const dataToSave = { ...this.remarksData }
      dataToSave.followUpTime = this.cleanTimeFormat(dataToSave.followUpTime)
      this.$emit('save', dataToSave)
      this.closeDialog()
    },
    cleanTimeFormat(time) {
      if (!time) return null
      if (time instanceof Date) {
        const hours = String(time.getHours()).padStart(2, '0')
        const minutes = String(time.getMinutes()).padStart(2, '0')
        return `${hours}:${minutes}`
      }
      if (typeof time === 'string' && time.includes(':')) {
        const parts = time.split(':')
        if (parts.length >= 2) {
          return `${parts[0]}:${parts[1]}`
        }
      }
      return time
    },
    closeDialog() {
      this.$emit('update:visible', false)
      this.dialogVisible = false
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
      } else {
        this.englishDateEnabled = false
      }
    },
    setNepaliDate() {
      if (this.nextFollowUpDate === '') {
        this.nextFollowUpDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.nextFollowUpDate = new Date().toISOString().slice(0, 10)
    },
    checkNepaliDateOrEnglishNext() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    nepaliDate() {
      this.$nextTick(() => {
        const element = document.getElementById('nextFollowUpDate')
        if (element) {
          $(element).nepaliDatePicker({
            ndpYear: true,
            ndpMonth: true,
            ndpYearCount: 10,
            disableBefore: this.$store.state.startDate,
            disableAfter: this.$store.state.endDate,
            onChange: () => {
              this.nextFollowUpDate = $('#nextFollowUpDate').val()
            }
          })
        }
      })
    }
  },
  mounted() {
    this.checkEnglish()
    this.$nextTick(() => {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    })
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// RemarksDialog.vue?0b770326